import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EventAttendeeTicket } from '@models/events/event-attendee-ticket.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-order-ticket-item',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule],
  templateUrl: './ticket-order-ticket-item.component.html',
  styleUrl: './ticket-order-ticket-item.component.scss',
})
export class TicketOrderTicketItemComponent {
  @Input() orderTicket!: EventAttendeeTicket;
  @Input() ticketIndex!: number;

  @Output() selectTicket = new EventEmitter<EventAttendeeTicket>();
  @Output() forwardTicket = new EventEmitter<EventAttendeeTicket>();

  onSelectTicket() {
    this.selectTicket.emit(this.orderTicket);
  }

  onForwardTicket(e: Event) {
    if (this.orderTicket.eventAttendee) {
      return;
    }

    e.stopPropagation();

    this.forwardTicket.emit(this.orderTicket);
  }
}
